export enum LayoutType {
  DEFAULT = 'default',
  CONTENT_ONLY = 'content-only',
  MOBILE = 'mobile',
}
